import { GraphQLClient, RequestDocument } from 'graphql-request';
// import { bootstrap as bootstrapGlobalAgent } from 'global-agent';
import { getSdk, SdkFunctionWrapper } from '@graphqlTypes/sitecore';
import Axios from 'axios';
import { setupCache } from 'axios-cache-interceptor';
import { logInfoWithTimestamp } from './logWithTimestamp';
const { buildAxiosFetch } = require('axios-fetch');

type Variables = {
    [x: string]: any;
};

const instance = Axios.create();
const axios = setupCache(instance, {
    methods: ['get', 'post'],
    debug: console.log,
    interpretHeader: false, // disable the Cache-Control headers
    ttl: parseInt(process.env.SITECORE_CACHE_TTL || '10000'),
});

// if (process.env.GALOBAL_HTTP_PROXY == 'true') {
//     bootstrapGlobalAgent({
//         environmentVariableNamespace: '',
//     });
// }

// Add request interceptor to log request details
axios.interceptors.request.use((request) => {
    // Temporary fix: unexpected content type issue
    request.headers['Content-Type'] = 'application/json';
    // Add operation name to the query params if any
    try {
        const body = typeof request.data === 'string' ? JSON.parse(request.data) : request.data;
        if (request.url && body.operationName) {
            const {
                operationName,
                variables: { lang },
            } = body;
            const urlWithParams = new URL(request.url);
            urlWithParams.searchParams.set('c', 'JCEW.CAMP-happywednesday');
            urlWithParams.searchParams.set('ops', `${operationName}_${lang}`);
            request.url = urlWithParams.toString();
        }
    } catch (err) {}

    logInfoWithTimestamp('Request', {
        url: request.url,
        // data: request.data,
    });
    return request;
});

// export const graphqlClient = new GraphQLClient(process.env.SITECORE_GRAPH_URL);
export const graphqlClient = new GraphQLClient(process.env.SITECORE_GRAPH_URL, {
    fetch: buildAxiosFetch(axios),
});

export function graphqlRequest<T = unknown>(
    document: RequestDocument,
    variables?: Variables,
): Promise<T> {
    return graphqlClient.request(document, variables);
}

const clientTimingWrapper: SdkFunctionWrapper = async <T>(action: () => Promise<T>): Promise<T> => {
    const result = await action();
    return result;
};
export const sitecoreClient = getSdk(graphqlClient, clientTimingWrapper);
